import React from "react";
import LayoutContainer from "containers/Layout";
import { Redirect, Switch } from "react-router-dom";
import { PrivateRoute } from "helper/route";
import Charging from "pages/ChargingTable";
import Dashboard from "pages/Dashboard";
import Booking from "pages/BookingTable";
import Customer from "pages/CustomerTable";
import CustomerDetail from "pages/CustomerDetail";
import AddStation from "pages/AddStation";
import EditStation from "pages/EditStation";
import MyProfile from "pages/MyProfile";
import Notification from "pages/Notification";
import StationDetail from "pages/StationDetail";
import Vendor from "pages/vendor//Vendor";
import Manufacturer from "pages/Manufacturer";
import ViewDetails from "pages/ViewDetails";
import VendorDetails from "pages/vendor/VendorDetails";
import VendorConfig from "pages/vendor/VendorConfig";
import VendorRequest from "pages/vendor/VendorRequest";
import RequestDetails from "pages/RequestDetails";
import MapPage from "pages/MapPage";
import VehicleManufacturerPage from "pages/VehicleManufacturerPage";
import VehicleModelPage from "pages/VehicleModelPage";
import ConnectorPage from "pages/ConnectorPage";
import AmenitiesPage from "pages/AmenitiesPage";
import CouponsPage from "pages/coupon/CouponsPage";
import AddCouponPage from "pages/coupon/AddCouponPage";
import ChargingNetworksPage from "pages/ChargingNetworkPage";
import VendorStation from "pages/vendor/VendorStation";
import Configuration from "pages/Configuration";
import RequestViewDetailsVendor from "pages/RequestViewDetailsVendor";
import ChargingRequest from "pages/ChargingRequest";
import VehicleVariantPage from "pages/VehicleVariantPage";
import FaqCategoryPage from "pages/faq/FaqCategoryPage";
import Faq from "pages/faq/Faq";
import FaqAdd from "pages/faq/FaqAdd";
import QureyPage from "pages/Qurey";
import LeadRequest from "pages/Leads";
import RequestPage from "pages/Request/RequestPage";
import CustomerDataPage from "pages/CustomerData/CustomerDataPage";
import ConnectorTypePage from "pages/connectorType/ConnectorType";
import vehiclespage from "pages/veicles/vehiclespage";
import AddConnectorPage from "pages/connectorType/AddConnectorPage";
import AddVehiclesPage from "pages/veicles/AddVehiclesPage";
import CheckinPage from "pages/customerAccounts/CheckinPage";
import NavigationPage from "pages/customerAccounts/NavigationPage";
import FeedbackPage from "pages/customerAccounts/FeedbackPage";
import SearchHistoryPage from "pages/customerAccounts/SearchHistoryPage";
import ChargingStation from "pages/ChargingStation/ChargingStation";
import CheckInCustomerDetails from "pages/CheckInCustomerDetails";
import TripDetailsPage from "pages/customerAccounts/TripDetailsPage";

const ChargingNavigator = (props) => {
  const { match } = props;
  const auth = { isAuthenticated: true };
  return (
    <>
      <Switch>
        <Redirect exact from={match.path} to={`${match.path}dashboard`} />
        <LayoutContainer {...props}>
          <Switch>
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}dashboard`}
              component={Dashboard}
            />
            {/* Manufacturer */}
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}manufacturer`}
              component={Manufacturer}
            />
              <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}connector`}
              component={ConnectorTypePage}
            />
             <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}vehicles`}
              component={vehiclespage}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}view/details`}
              component={ViewDetails}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}request/details`}
              component={RequestDetails}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}request/details/Vendor`}
              component={RequestViewDetailsVendor}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}vendor/details`}
              component={VendorDetails}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}vendor/station`}
              component={VendorStation}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}map`}
              component={MapPage}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}amenities`}
              component={AmenitiesPage}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}coupons`}
              component={CouponsPage}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}add/coupons`}
              component={AddCouponPage}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}vendor/config`}
              component={VendorConfig}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}vehicle/manufacturer`}
              component={VehicleManufacturerPage}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}vehicle/Variant`}
              component={VehicleVariantPage}
            />
              <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}connector/addconnector`}
              component={AddConnectorPage}
            />
             <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}vehicles/addvehicles`}
              component={AddVehiclesPage}
            />
              <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}checkin`}
              component={CheckinPage}
            />
             <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}trip`}
              component={TripDetailsPage}
            />
              <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}navigation`}
              component={NavigationPage}
            />
             <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}feedback`}
              component={FeedbackPage}
            />
             <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}searchhistory`}
              component={SearchHistoryPage}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}vendor/request`}
              component={VendorRequest}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}charging/request`}
              component={ChargingRequest}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}vehicle/model`}
              component={VehicleModelPage}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}add/connectors`}
              component={ConnectorPage}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}add/connectors`}
              component={ConnectorPage}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}networks`}
              component={ChargingNetworksPage}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}customerdata`}
              component={CustomerDataPage}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}charging`}
              component={Charging}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}request`}
              component={RequestPage}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}configuration`}
              component={Configuration}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}booking`}
              component={Booking}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}leads`}
              component={LeadRequest}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}customer`}
              component={Customer}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}vendor`}
              component={Vendor}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}query`}
              component={QureyPage}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}customer/details/:id`}
              component={CustomerDetail}
              render={(props) => {
                const customerId = this.props.computedMatch.params.id;

                return <CustomerDetail {...props} customerId={customerId} />;
              }}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}station/details/:id`}
              component={StationDetail}
              render={(props) => {
                const stationId = this.props.computedMatch.params.id;

                return <StationDetail {...props} stationId={stationId} />;
              }}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}add/station`}
              component={AddStation}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}edit/station/:id`}
              component={EditStation}
              render={(props) => {
                const stationId = this.props.computedMatch.params.id;
                return <EditStation {...props} stationId={stationId} />;
              }}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}profile`}
              component={MyProfile}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}notifications`}
              component={Notification}
            />
              <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}chargingstation`}
              component={ChargingStation}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}faq/category`}
              component={FaqCategoryPage}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}faqs`}
              component={Faq}
            />
            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}faq/add`}
              component={FaqAdd}
            />

            <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}faq/edit/:id`}
              component={FaqAdd}
              render={(props) => {
                const Id = this.props.computedMatch.params.id;

                return <FaqAdd {...props} Id={Id} />;
              }}
            />

          <PrivateRoute
              exact
              auth={auth}
              path={`${match.path}checkIn/customer/details/:id`}
              component={CheckInCustomerDetails}
              render={(props) => {
                const customerId = this.props.computedMatch.params.id;

                return <CheckInCustomerDetails {...props} customerId={customerId} />;
              }}
            />
          </Switch>
        </LayoutContainer>
      </Switch>
    </>
  );
};

export default ChargingNavigator;
